"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Entry = Entry;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var require_facility_1 = require("./components/auth/require-facility");
var superadmin_guard_1 = require("./components/auth/superadmin-guard");
var content_1 = require("./components/dialogs/content");
var message_1 = require("./components/dialogs/message");
var console_layout_1 = require("./components/layouts/console-layout");
var routes_1 = require("./constants/routes");
var account_suspended_1 = require("./pages/account-suspended");
var administration_1 = require("./pages/administration");
var alarm_view_1 = require("./pages/alarm-view");
var alarms_1 = require("./pages/alarms");
var area_library_1 = require("./pages/area-library");
var accept_invitation_1 = require("./pages/auth/accept-invitation");
var forgot_password_1 = require("./pages/auth/forgot-password");
var login_1 = require("./pages/auth/login");
var reset_password_1 = require("./pages/auth/reset-password");
var validate_account_1 = require("./pages/auth/validate-account");
var client_list_1 = require("./pages/client-list");
var client_view_1 = require("./pages/client-view");
var clone_batch_view_1 = require("./pages/clone-batch-view");
var device_view_1 = require("./pages/device-view");
var devices_1 = require("./pages/devices");
var ewelink_callback_1 = require("./pages/ewelink-callback");
var facility_dashboard_1 = require("./pages/facility-dashboard");
var facility_management_1 = require("./pages/facility-management");
var facility_view_1 = require("./pages/facility-view");
var grow_cycle_sop_view_1 = require("./pages/grow-cycle-sop-view");
var grow_cycle_view_1 = require("./pages/grow-cycle-view");
var grow_cycles_1 = require("./pages/grow-cycles");
var integrations_1 = require("./pages/integrations");
var invitations_1 = require("./pages/invitations");
var mother_plant_view_1 = require("./pages/mother-plant-view");
var mother_room_1 = require("./pages/mother-room");
var not_found_1 = require("./pages/not-found");
var notification_view_1 = require("./pages/notification-view");
var notifications_1 = require("./pages/notifications");
var organization_1 = require("./pages/organization");
var privacy_policy_1 = require("./pages/privacy-policy");
var profile_1 = require("./pages/profile");
var seed_view_1 = require("./pages/seed-view");
var billing_1 = require("./pages/settings/billing");
var index_1 = require("./pages/settings/index");
var permissions_1 = require("./pages/settings/permissions");
var sop_library_1 = require("./pages/sop-library");
var sop_library_view_1 = require("./pages/sop-library-view");
var starting_material_1 = require("./pages/starting-material");
var task_dashboard_1 = require("./pages/task-dashboard");
var task_view_1 = require("./pages/task-view");
var terms_1 = require("./pages/terms");
var user_view_1 = require("./pages/user-view");
var users_1 = require("./pages/users");
function Entry() {
    var routes = (0, react_router_dom_1.useRoutes)([
        {
            path: routes_1.ROUTES.HOME,
            index: true,
            element: (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: routes_1.ROUTES.TASKS_DASHBOARD, replace: true }),
        },
        {
            path: routes_1.ROUTES.AUTH,
            children: [
                { index: true, element: (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: routes_1.ROUTES.LOGIN, replace: true }) },
                { path: routes_1.ROUTES.LOGIN, element: (0, jsx_runtime_1.jsx)(login_1.LoginPage, {}) },
                { path: routes_1.ROUTES.VALIDATE_ACCOUNT, element: (0, jsx_runtime_1.jsx)(validate_account_1.ValidateAccountPage, {}) },
                { path: routes_1.ROUTES.FORGOT_PASSWORD, element: (0, jsx_runtime_1.jsx)(forgot_password_1.ForgotPasswordPage, {}) },
                { path: routes_1.ROUTES.RESET_PASSWORD, element: (0, jsx_runtime_1.jsx)(reset_password_1.ResetPasswordPage, {}) },
                { path: routes_1.ROUTES.ACCEPT_INVITATION, element: (0, jsx_runtime_1.jsx)(accept_invitation_1.AcceptInvitationPage, {}) },
            ],
        },
        {
            path: routes_1.ROUTES.LEGACY_LOGIN,
            element: (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: routes_1.ROUTES.LOGIN, replace: true }),
        },
        {
            path: routes_1.ROUTES.ACCOUNT_SUSPENDED,
            element: (0, jsx_runtime_1.jsx)(account_suspended_1.AccountSuspendedPage, {}),
        },
        { path: routes_1.ROUTES.PRIVACY_POLICY, element: (0, jsx_runtime_1.jsx)(privacy_policy_1.PrivacyPolicyPage, {}) },
        { path: routes_1.ROUTES.TERMS, element: (0, jsx_runtime_1.jsx)(terms_1.TermsPage, {}) },
        {
            element: (0, jsx_runtime_1.jsx)(console_layout_1.ConsoleLayout, {}),
            children: [
                {
                    element: (0, jsx_runtime_1.jsx)(require_facility_1.RequireFacility, {}),
                    children: [
                        {
                            path: routes_1.ROUTES.TASKS_DASHBOARD,
                            children: [
                                { index: true, element: (0, jsx_runtime_1.jsx)(task_dashboard_1.TaskDashboardPage, {}) },
                                { path: routes_1.ROUTES.TASK_VIEW, element: (0, jsx_runtime_1.jsx)(task_view_1.TaskViewPage, {}) },
                            ],
                        },
                        { path: routes_1.ROUTES.FACILITY_DASHBOARD, element: (0, jsx_runtime_1.jsx)(facility_dashboard_1.FacilityDashboardPage, {}) },
                        {
                            path: routes_1.ROUTES.ALARMS,
                            children: [
                                { index: true, element: (0, jsx_runtime_1.jsx)(alarms_1.AlarmsPage, {}) },
                                { path: routes_1.ROUTES.ALARM_VIEW, element: (0, jsx_runtime_1.jsx)(alarm_view_1.AlarmViewPage, {}) },
                            ],
                        },
                    ],
                },
                {
                    path: routes_1.ROUTES.NOTIFICATIONS,
                    children: [
                        { index: true, element: (0, jsx_runtime_1.jsx)(notifications_1.NotificationsPage, {}) },
                        { path: routes_1.ROUTES.NOTIFICATION_VIEW, element: (0, jsx_runtime_1.jsx)(notification_view_1.NotificationViewPage, {}) },
                    ],
                },
                {
                    path: routes_1.ROUTES.FACILITY_MANAGEMENT,
                    children: [
                        { index: true, element: (0, jsx_runtime_1.jsx)(facility_management_1.FacilityManagementPage, {}) },
                        { path: routes_1.ROUTES.FACILITY_VIEW, element: (0, jsx_runtime_1.jsx)(facility_view_1.FacilityViewPage, {}) },
                    ],
                },
                {
                    element: (0, jsx_runtime_1.jsx)(require_facility_1.RequireFacility, {}),
                    children: [
                        {
                            path: routes_1.ROUTES.GROW_CYCLES,
                            children: [
                                { index: true, element: (0, jsx_runtime_1.jsx)(grow_cycles_1.GrowCyclesPage, {}) },
                                { path: routes_1.ROUTES.GROW_CYCLE_VIEW, element: (0, jsx_runtime_1.jsx)(grow_cycle_view_1.GrowCycleViewPage, {}) },
                                { path: routes_1.ROUTES.GROW_CYCLE_SOP_VIEW, element: (0, jsx_runtime_1.jsx)(grow_cycle_sop_view_1.GrowCycleSopViewPage, {}) },
                            ],
                        },
                        {
                            path: routes_1.ROUTES.DEVICES,
                            children: [
                                { index: true, element: (0, jsx_runtime_1.jsx)(devices_1.DevicesPage, {}) },
                                { path: routes_1.ROUTES.DEVICE_VIEW, element: (0, jsx_runtime_1.jsx)(device_view_1.DeviceViewPage, {}) },
                            ],
                        },
                        {
                            path: routes_1.ROUTES.STARTING_MATERIAL,
                            children: [
                                { index: true, element: (0, jsx_runtime_1.jsx)(starting_material_1.StartingMaterialPage, {}) },
                                { path: routes_1.ROUTES.SEED_VIEW, element: (0, jsx_runtime_1.jsx)(seed_view_1.SeedViewPage, {}) },
                            ],
                        },
                        {
                            path: routes_1.ROUTES.MOTHER_ROOM,
                            children: [
                                { index: true, element: (0, jsx_runtime_1.jsx)(mother_room_1.MotherRoomPage, {}) },
                                { path: routes_1.ROUTES.MOTHER_PLANT_VIEW, element: (0, jsx_runtime_1.jsx)(mother_plant_view_1.MotherPlantViewPage, {}) },
                                { path: routes_1.ROUTES.CLONE_BATCH_VIEW, element: (0, jsx_runtime_1.jsx)(clone_batch_view_1.CloneBatchViewPage, {}) },
                            ],
                        },
                    ],
                },
                {
                    path: routes_1.ROUTES.QUALITY_MANAGEMENT,
                    children: [
                        { index: true, element: (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: routes_1.ROUTES.SOP_LIBRARY, replace: true }) },
                        { path: routes_1.ROUTES.SOP_LIBRARY, element: (0, jsx_runtime_1.jsx)(sop_library_1.SopLibraryPage, {}) },
                        { path: routes_1.ROUTES.SOP_LIBRARY_VIEW, element: (0, jsx_runtime_1.jsx)(sop_library_view_1.SopLibraryViewPage, {}) },
                        { path: routes_1.ROUTES.AREA_LIBRARIES, element: (0, jsx_runtime_1.jsx)(area_library_1.AreaLibraryPage, {}) },
                    ],
                },
                {
                    path: routes_1.ROUTES.USER_MANAGEMENT,
                    children: [
                        { index: true, element: (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: routes_1.ROUTES.USERS, replace: true }) },
                        {
                            path: routes_1.ROUTES.USERS,
                            children: [
                                { index: true, element: (0, jsx_runtime_1.jsx)(users_1.UsersPage, {}) },
                                { path: routes_1.ROUTES.USER_VIEW, element: (0, jsx_runtime_1.jsx)(user_view_1.UserViewPage, {}) },
                            ],
                        },
                        { path: routes_1.ROUTES.ADMINISTRATION, element: (0, jsx_runtime_1.jsx)(administration_1.AdministrationPage, {}) },
                    ],
                },
                {
                    path: routes_1.ROUTES.CLIENTS,
                    element: (0, jsx_runtime_1.jsx)(superadmin_guard_1.SuperadminGuard, {}),
                    children: [
                        { index: true, element: (0, jsx_runtime_1.jsx)(react_router_dom_1.Navigate, { to: routes_1.ROUTES.CLIENT_LIST, replace: true }) },
                        { path: routes_1.ROUTES.CLIENT_LIST, element: (0, jsx_runtime_1.jsx)(client_list_1.ClientListPage, {}) },
                        { path: routes_1.ROUTES.CLIENT_INVITATIONS, element: (0, jsx_runtime_1.jsx)(invitations_1.InvitationsPage, {}) },
                        { path: routes_1.ROUTES.CLIENT_VIEW, element: (0, jsx_runtime_1.jsx)(client_view_1.ClientViewPage, {}) },
                    ],
                },
                { path: routes_1.ROUTES.PROFILE, element: (0, jsx_runtime_1.jsx)(profile_1.ProfilePage, {}) },
                { path: routes_1.ROUTES.ORGANIZATION, element: (0, jsx_runtime_1.jsx)(organization_1.OrganizationPage, {}) },
                {
                    path: routes_1.ROUTES.SETTINGS,
                    children: [
                        { index: true, element: (0, jsx_runtime_1.jsx)(index_1.SettingsIndexPage, {}) },
                        { path: routes_1.ROUTES.BILLING_SETTINGS, element: (0, jsx_runtime_1.jsx)(billing_1.BillingSettingsPage, {}) },
                        { path: routes_1.ROUTES.PERMISSIONS_SETTINGS, element: (0, jsx_runtime_1.jsx)(permissions_1.PermissionsSettingsPage, {}) },
                    ],
                },
                {
                    path: routes_1.ROUTES.INTEGRATIONS,
                    children: [
                        { index: true, element: (0, jsx_runtime_1.jsx)(integrations_1.IntegrationsPage, {}) },
                        { path: routes_1.ROUTES.EWELINK_CALLBACK, element: (0, jsx_runtime_1.jsx)(ewelink_callback_1.EwelinkCallbackPage, {}) },
                    ],
                },
            ],
        },
        {
            path: routes_1.ROUTES.NOT_FOUND,
            element: (0, jsx_runtime_1.jsx)(not_found_1.NotFoundPage, {}),
        },
    ]);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "h-screen min-w-[550px]", children: [routes, (0, jsx_runtime_1.jsx)(content_1.ContentDialog, {}), (0, jsx_runtime_1.jsx)(message_1.MessageDialog, {})] }));
}
